import axios from 'axios';

export const mailingListUpdate = async (formPayload) => {
    const headers = {
        'Content-Type': 'application/json'
    }

    const data = {
        service_id: process.env.REACT_APP_EMAIL_JS_SERVICE_ID,
        template_id: process.env.REACT_APP_EMAIL_JS_TEMPLATE_ID,
        user_id: process.env.REACT_APP_EMAIL_JS_USER_ID,
        template_params: {
            'email': formPayload.email,
            'guardianName': formPayload.guardianName,
            'childName': formPayload.childName,
            'hasPriorExperience': formPayload.hasPriorExperience,
            'isReadyToSchedule': formPayload.isReadyToSchedule,
            'whyMusicTherapy': formPayload.whyMusicTherapy
        }
    };

    try {
        const response = await axios.post(process.env.REACT_APP_EMAIL_JS_URL, data, {
            headers: headers
        });
        return response.data;
    } catch (error) {
        console.log('ERR: ', error);
    }
};